module.exports = __webpack_public_path__ + "static/media/anc11ru.4437bc55.pdf";